<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'">
        </mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user?.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="profile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item (click)="changePassword()">
        <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
        <span>Change Password</span>
    </button>
    <button mat-menu-item *ngIf="roles?.length == 1">
        <mat-icon [svgIcon]="'heroicons_solid:shield-check'"></mat-icon>
        <span class="break-words">{{roleString}}</span>
    </button>
    <button matRipple [matMenuTriggerFor]="projectsMenu" mat-menu-item
        *ngIf="roles?.length > 1" (click)="$event.stopPropagation();">
        <mat-icon [svgIcon]="'heroicons_solid:shield-check'"></mat-icon>
        Change Role ({{selectedTab}})
    </button>

    <mat-menu #projectsMenu="matMenu" [xPosition]="'before'">
        <button mat-menu-item *ngFor="let tab of tabs;let idx=index"
            (click)="onChangeRole(idx, true)">{{tab}}
        </button>
    </mat-menu>
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Settings</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="adminMenu">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>Admin</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #adminMenu="matMenu">
    <a mat-menu-item [routerLink]="['/admin/personnel/users']">
        <span>Users</span>
    </a>
    <a mat-menu-item [routerLink]="['/admin/settings']">
        <span>Settings</span>
    </a>
</mat-menu>
